import React, { useEffect, useState, useContext } from 'react';
import { Calendar, momentLocalizer, Views } from 'react-big-calendar';
import { Card } from 'react-bootstrap'; // Add Card, Row, Col for summary boxes
import LoginHistory from '../../components/LoginHistory';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { AppointmentContext } from '../../context/AppointmentContext';
import { Modal, Button, Form } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext'; // ✅ Import useAuth
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import moment from 'moment-timezone';
import Prescription from './Prescription'; // Import Prescription component
import LabTest from './LabTest'; 
import toast from 'react-hot-toast';

const BASE_URL = process.env.REACT_APP_BASE_URL; // Adjust the base URL as needed

const localizer = momentLocalizer(moment);
const DoctorDashboard = () => {
  const { user } = useAuth(); // ✅ Get user data from Auth Context
  const loggedInHospitalId = user?.hospital_id || null;
  const { fetchAppointments } = useContext(AppointmentContext);
  const [events, setEvents] = useState([]);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  // const [view, setView] = useState(Views.MONTH); // Default view is monthly
  const [currentView, setCurrentView] = useState(Views.WEEK);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [showModal, setShowModal] = useState(false);

  const [doctors, setDoctors] = useState([]);
  const [selectedSubHospital, setSelectedSubHospital] = useState(null);
  const [newEvent, setNewEvent] = useState({
    title: '',
    start: '',
    end: '',
    doctorIds: [], // ✅ Updated to handle multiple doctor IDs
    hospitalId: loggedInHospitalId, // ✅ Auto-fetch hospital ID
    subHospitalId: '', // ✅ Auto-populate based on selection
    recurringDays: [], // ✅ New field for recurring days
    recurringWeeks: [], // ✅ New field for recurring weeks
    isSpecificDate: false, // ✅ New field for specific date
  });
  const [notes, setNotes] = useState('');
  const [followUpAction, setFollowUpAction] = useState('');
  const [status, setStatus] = useState('');
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const [showLabTestModal, setShowLabTestModal] = useState(false); // LabTest modal state
  const token = localStorage.getItem('token');
  const showWarning = (message) => {
    toast(message, {
      icon: '⚠️',
      style: {
        background: '#fffbe6',
        color: '#664d03',
        border: '1px solid #ffecb5',
      },
    });
  };

    const navigate = useNavigate();

  useEffect(() => {
    // Add an extra entry to browser history
    window.history.pushState(null, "", window.location.href);

    const handleBack = () => {
      window.history.go(1); // prevent back
    };

    window.addEventListener("popstate", handleBack);

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, []);

  // Fetch both availabilities and appointments for the doctor
  const fetchCalendarEvents = async (rangeStart, rangeEnd) => {
    try {
      // Use the correct token and handle missing token
      const token = localStorage.getItem('token');
      if (!token) {
        alert('You are not logged in. Please log in again.');
        return;
      }
      const doctorId = localStorage.getItem('doctor_id');
      console.log('Fetchinggggggggggggggg events for doctor ID:', doctorId);
      const hospitalId = localStorage.getItem('hospitalId');
      const subHospitalId = localStorage.getItem('subHospitalId');

      // Fetch appointments from the appointments table
      const apptRes = await axios.get(`${BASE_URL}/api/doctor/appointments`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          doctorId,
          hospitalId,
          subHospitalId,
          startDate: moment(rangeStart).format('YYYY-MM-DD'),
          endDate: moment(rangeEnd).format('YYYY-MM-DD'),
        },
      });

      // Map appointments to calendar events
      const apptEvents = apptRes.data
        .map((appointment) => {
          // Use date, start_time, end_time from response
          const dateStr = appointment.date;

          const startTime = appointment.start_time;
          const endTime = appointment.end_time;
          // Combine date and time for calendar event

          const start = moment
            .tz(`${dateStr} ${startTime}`, 'YYYY-MM-DD HH:mm', 'Asia/Kolkata')
            .toDate();
          const end = moment
            .tz(`${dateStr} ${endTime}`, 'YYYY-MM-DD HH:mm', 'Asia/Kolkata')
            .toDate();

          return {
            id: `appt-${appointment.id}`,
            // title: `Appointment with ${appointment.patientName || appointment.patient_id}`,
            start,
            end,
            allDay: false,
            status: appointment.status,
            type: 'appointment',
            ...appointment,
          };
        })
        .filter(
          (event) =>
            event.start &&
            event.end &&
            !isNaN(event.start) &&
            !isNaN(event.end),
        );

      setEvents(apptEvents);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        showWarning('Session expired or unauthorized. Please log in again.');
        // Optionally, redirect to login page here
      }
      console.error('Error fetching calendar events:', error);
    }
  };

  // Fetch events for current week on mount and on date change
  useEffect(() => {
    const fetchEventsForCurrentWeek = () => {
      const startOfWeek = moment(currentDate)
        .startOf('week')
        .startOf('day')
        .toDate();
      const endOfWeek = moment(currentDate).endOf('week').endOf('day').toDate();
      fetchCalendarEvents(startOfWeek, endOfWeek);
    };
    fetchEventsForCurrentWeek();
    const intervalId = setInterval(fetchEventsForCurrentWeek, 10000);
    return () => clearInterval(intervalId);
  }, [currentDate, user?.id]);

  useEffect(() => {
    fetchAppointments(); // Fetch appointments on component mount
  }, [fetchAppointments]);

  // Status color mapping for modal and calendar
  const getStatusColor = (status) => {
    switch ((status || '').toLowerCase()) {
      case 'pending':
        return '#FFE082'; // Amber 300 — light, readable yellow
      case 'confirmed':
        return '#81C784'; // Green 300 — soft but clear green
      case 'cancel':
        return '#778899'; // Red 300 — balanced red tone
      case 'completed':
        return '#B0BEC5'; // Blue Grey 200 — clean and neutral
      default:
        return '#64B5F6'; // Blue 300 — standard fallback
    }
  };

  const getStatusIcon = (status) => {
    switch ((status || '').toLowerCase()) {
      case 'pending':
        return 'hourglass_empty'; // ⏳
      case 'confirmed':
        return 'check_circle'; // ✅
      case 'cancel':
        return 'cancel'; // 🔁
      case 'completed':
        return 'task_alt'; // 🗸
      default:
        return 'info'; // ℹ️
    }
  };

  // Update appointment status in DB and UI
  const handleStatusChange = async (newStatus) => {
    if (!selectedAppointment) return;

    let formattedStatus = null;

    if (
      newStatus === 'confirmed' &&
      selectedAppointment.status.toLowerCase() === 'pending'
    ) {
      formattedStatus = 'Confirmed';
    } else if (
      newStatus === 'completed' &&
      selectedAppointment.status.toLowerCase() === 'confirmed'
    ) {
      formattedStatus = 'Completed';
    } else if (newStatus === 'rescheduled') {
      formattedStatus = 'Rescheduled';
    } else if (newStatus === 'cancel') {
      formattedStatus = 'Cancel';
    } else {
      toast.error(
        `Cannot mark "${selectedAppointment.status}" as "${newStatus}"`,
      );
      return;
    }

    try {
      await axios.put(
        `${BASE_URL}/api/doctor/appointments/${selectedAppointment.id}`,
        {
          status: formattedStatus,
          notes: notes || '',
          followUpAction: followUpAction || '',
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        },
      );

      // Send email only if status changed from pending to confirmed
      if (
        formattedStatus === 'Confirmed' &&
        selectedAppointment.status.toLowerCase() === 'pending'
      ) {
        try {
          await axios.post(
            `${BASE_URL}/api/notification/confirm`,
            {
              appointmentId: selectedAppointment.id,
              patientId: selectedAppointment.patient_id,
            },
            { headers: { Authorization: `Bearer ${token}` } },
          );

          // ✅ Show success message
          toast.success('Appointment confirmed and email sent!');

          // ✅ Now refresh the data or update UI
          fetchAppointments(); // <-- you must define and call this
        } catch (emailError) {
          console.error('Failed to send confirmation email:', emailError);
          toast.error('Failed to send confirmation email.');
        }
      }

      setSelectedAppointment({
        ...selectedAppointment,
        status: formattedStatus,
        notes: notes || '',
        followUpAction: followUpAction || '',
      });
      setStatus(formattedStatus);

      setEvents((prevEvents) =>
        prevEvents.map((evt) =>
          evt.id === selectedAppointment.id ||
          evt.id === `appt-${selectedAppointment.id}`
            ? { ...evt, status: formattedStatus }
            : evt,
        ),
      );
    } catch (error) {
      console.error('Failed to update appointment:', error);
      toast.error('Failed to update appointment');
    }
  };

  const eventStyleGetter = (event) => {
    const color = getStatusColor(event.status);
    return color ? { style: { backgroundColor: color } } : { style: {} }; // No color for completed
  };

  const handleModalClose = () => {
    setSelectedAppointment(null);
  };

  // On calendar range change, fetch appointments for that range
  const handleRangeChange = (range) => {
    let start, end;
    if (Array.isArray(range)) {
      // Month view: range is array of dates
      start = range[0];
      end = range[range.length - 1];
    } else {
      // Week/day view: range is {start, end}
      start = range.start;
      end = range.end;
    }
    fetchCalendarEvents(start, end);
  };

  const handleSelectSlot = ({ start, end }) => {
    // Open the modal only for creating a new event
    setNewEvent({
      title: '',
      start,
      end,
      doctorIds: [], // ✅ Initialize with empty array
      hospitalId: loggedInHospitalId, // ✅ Auto-fetch hospital ID
      subHospitalId: selectedSubHospital, // ✅ Auto-fetch selected sub-hospital
      recurringDays: [],
      recurringWeeks: [],
      isSpecificDate: false,
    });
    setShowModal(true);
  };

  const handleSelectEvent = async (event) => {
    if (event.type === 'appointment') {
      let apptId = event.id;
      if (typeof apptId === 'string' && apptId.startsWith('appt-')) {
        apptId = parseInt(apptId.replace('appt-', ''), 10);
      }
      const appointment = events.find(
        (evt) =>
          evt.type === 'appointment' &&
          (evt.id === event.id ||
            evt.id === `appt-${apptId}` ||
            evt.id === apptId),
      );
      if (appointment && appointment.patientName) {
        const patientDetails = {
          name: appointment.patientName,
          age: appointment.patientAge,
          gender: appointment.patientGender,
          // Add phone, email if available in backend response
        };
        setSelectedAppointment({ ...appointment, patientDetails });
      } else {
        setSelectedAppointment(appointment);
      }
    } else if (event.type === 'availability') {
      let availId = event.id;
      if (typeof availId === 'string' && availId.startsWith('avail-')) {
        availId = availId.replace('avail-', '');
      }
      axios
        .get(
          `${BASE_URL}/api/doctorAvailability/getDoctorAvailabilityById/${availId}`,
        )
        .then((response) => {
          const fetchedEvent = response.data;
          setNewEvent({
            ...fetchedEvent,
            hospitalId: loggedInHospitalId,
            doctorIds: fetchedEvent.doctorIds || [],
            subHospitalId: fetchedEvent.subHospitalId || '',
            start: moment(fetchedEvent.start).format('YYYY-MM-DDTHH:mm'),
            end: moment(fetchedEvent.end).format('YYYY-MM-DDTHH:mm'),
            recurringDays: fetchedEvent.recurringDays?.split(',') || [],
            recurringWeeks: fetchedEvent.recurringWeeks?.split(',') || [],
            isSpecificDate: fetchedEvent.isSpecificDate || false,
          });

          axios
            .get(
              `${BASE_URL}/api/doctorAvailability/getDoctorsByHospitalAndSubHospital`,
              {
                params: {
                  hospitalId: loggedInHospitalId,
                  subHospitalId: fetchedEvent.subHospitalId,
                },
              },
            )
            .then((response) => setDoctors(response.data))
            .catch((error) => console.error('Error fetching doctors:', error));

          setShowModal(true);
        })
        .catch((error) =>
          console.error('Error fetching event details:', error),
        );
    }
  };

  // When an appointment is selected, set modal fields
  useEffect(() => {
    if (selectedAppointment) {
      setNotes(selectedAppointment.notes || '');
      setFollowUpAction(selectedAppointment.followUpAction || '');
      setStatus(selectedAppointment.status || '');
    }
  }, [selectedAppointment]);

  // Add stats state
  const [stats, setStats] = useState({
    todayAppointments: 0,
    pendingApprovals: 0,
    // totalPatients: 0,
  });

  // Fetch stats for doctor
  useEffect(() => {
    const token = localStorage.getItem('token');
    const doctorId = localStorage.getItem('doctor_id');
    const hospitalId = localStorage.getItem('hospitalId');
    const subHospitalId = localStorage.getItem('subHospitalId');
    
    if (token && doctorId && hospitalId && subHospitalId) {
      // Today's Appointments
      axios
        .get(`${BASE_URL}/api/patientAppointment/todays-appointments`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            hospital_id: hospitalId,
            subhospital_id: subHospitalId,
            doctor_id: doctorId,
          },
        })
        .then((res) => {
          setStats((prev) => ({
            ...prev,
            todayAppointments: (res.data || []).length,
          }));
        })
        .catch(() => setStats((prev) => ({ ...prev, todayAppointments: 0 })));

      // Pending Approvals
      axios
        .get(`${BASE_URL}/api/patientAppointment/pending-appointments`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            hospital_id: hospitalId,
            subhospital_id: subHospitalId,
            doctor_id: doctorId,
          },
        })
        .then((res) => {
          setStats((prev) => ({
            ...prev,
            pendingApprovals: (res.data || []).length,
          }));
        })
        .catch(() => setStats((prev) => ({ ...prev, pendingApprovals: 0 })));

      // Total Patients
      // axios
      //   .get(`${BASE_URL}/api/patientAppointment/appointments`, {
      //     headers: { Authorization: `Bearer ${token}` },
      //     params: {
      //       hospital_id: hospitalId,
      //       subhospital_id: subHospitalId,
      //       doctor_id: doctorId,
      //     },
      //   })
      //   .then((res) => {
      //     setStats((prev) => ({
      //       ...prev,
      //       totalPatients: new Set((res.data || []).map((a) => a.patientName))
      //         .size,
      //     }));
      //   })
      //   .catch(() => setStats((prev) => ({ ...prev, totalPatients: 0 })));
    }
  }, [user?.id]);

  return (
    <div
      className="d-flex"
      style={{ minHeight: '100vh', background: 'var(--admin-bg)' }}
    >
      {/* <Sidebar /> */}
      <div
        className="flex-grow-1 p-4"
        style={{ background: 'var(--admin-bg)' }}
      >
        {/* Welcome message and summary boxes in a row */}
        <div className="mb-4 d-flex flex-column flex-md-row align-items-center justify-content-between">
          <div>
            <h2 className="global-heading" style={{ marginBottom: 0 }}>
              Welcome, Dr. {user?.name || 'Doctor'}!
            </h2>
            <div
              style={{
                fontSize: '1.08rem',
                color: '#444',
                marginBottom: 0,
                fontWeight: 500,
              }}
            >
              Manage your appointments and availability with ease.
            </div>
          </div>

          {/* Small summary boxes */}
          <div className="d-flex gap-2 mt-3 mt-md-0">
            <Card
              style={{
                minWidth: 120,
                minHeight: 70,
                borderRadius: 10,
                boxShadow: '0 1px 6px #e0e0e0',
                background: '#fff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Card.Body className="p-2 text-center">
                <div style={{ fontSize: 13, color: '#888' }}>
                  {`Today's Appointments`}
                </div>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 22,
                    color: 'var(--primary-color)',
                  }}
                >
                  {stats.todayAppointments}
                </div>
              </Card.Body>
            </Card>
            <Card
              style={{
                minWidth: 120,
                minHeight: 70,
                borderRadius: 10,
                boxShadow: '0 1px 6px #e0e0e0',
                background: '#fff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Card.Body className="p-2 text-center">
                <div style={{ fontSize: 13, color: '#888' }}>
                  Pending Approvals
                </div>
                <div
                  style={{ fontWeight: 700, fontSize: 22, color: '#f0ad4e' }}
                >
                  {stats.pendingApprovals}
                </div>
              </Card.Body>
            </Card>
            {/* <Card
              style={{
                minWidth: 120,
                minHeight: 70,
                borderRadius: 10,
                boxShadow: '0 1px 6px #e0e0e0',
                background: '#fff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Card.Body className="p-2 text-center">
                <div style={{ fontSize: 13, color: '#888' }}>
                  Total Patients
                </div>
                <div
                  style={{ fontWeight: 700, fontSize: 22, color: '#1cc88a' }}
                >
                  {stats.totalPatients}
                </div>
              </Card.Body>
            </Card> */}

            <Card
              style={{
                minWidth: 120,
                minHeight: 70,
                borderRadius: 10,
                boxShadow: '0 1px 6px #e0e0e0',
                background: '#fff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Card.Body className="p-2 text-center">
                <div style={{ fontSize: 13, color: '#888' }}>{`Today's Time`}</div>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 22,
                    color: 'var(--primary-color)',
                  }}
                >
                  <LoginHistory userId={user?.id} />
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>

        {/* Calendar component */}
        <div
          className="calendar-container mt-4"
          style={{
            background: '#fff',
            borderRadius: 14,
            boxShadow: '0 2px 12px rgba(10,120,132,0.07)',
            padding: '18px 10px 10px 10px',
          }}
        >
          <Calendar
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            selectable
            style={{ height: '70vh' }}
            views={[Views.DAY, Views.WEEK, Views.MONTH]}
            view={currentView}
            date={currentDate}
            onView={(view) => setCurrentView(view)}
            onNavigate={(date) => setCurrentDate(date)}
            onSelectSlot={handleSelectSlot}
            onSelectEvent={handleSelectEvent}
            onRangeChange={handleRangeChange}
            eventPropGetter={eventStyleGetter}
          />
        </div>

        {/* Appointment Details Modal */}
        {selectedAppointment && (
          <Modal
            show={!!selectedAppointment}
            onHide={handleModalClose}
            centered
            size="md"
            className="custom-modal"
          >
            <Modal.Header
              closeButton
              className="border-0"
              style={{ backgroundColor: '#f8f9fa' }}
            >
              <Modal.Title>
                <h5 className="fw-bold globle-heading primary-class">
                Appointment Details
                </h5>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-3">
              <div className="mb-3">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <h5 className="fw-bold globle-heading">
                    Patient Details
                  </h5>
                  <div className="d-flex align-items-center gap-2">
                    {selectedAppointment.status &&
                      selectedAppointment.status.toLowerCase() ===
                        'confirmed' && (
                        <>
                          <Button
                            variant="light"
                            size="sm"
                           className="btn-custom-outline"
                            onClick={() => setShowPrescriptionModal(true)}
                          >
                            Prescription
                          </Button>
                          <Button
                            variant="light"
                            size="sm"
                            className="btn-custom-outline"
                            onClick={() => setShowLabTestModal(true)}
                          >
                            Lab
                          </Button>
                        </>
                      )}
                  </div>
                </div>
                <div className="row g-2">
                  <div className="col-6">
                    <div className="modal-label">
                      <b>Name:</b>
                    </div>
                    <div className="modal-value">
                      {selectedAppointment.patientDetails?.name || (
                        <span className="text-danger">N/A</span>
                      )}
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="modal-label">
                      <b>Age:</b>
                    </div>
                    <div className="modal-value">
                      {selectedAppointment.patientDetails?.age || (
                        <span className="text-danger">N/A</span>
                      )}
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="modal-label">
                      <b>Gender:</b>
                    </div>
                    <div className="modal-value">
                      {selectedAppointment.patientDetails?.gender || (
                        <span className="text-danger">N/A</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <hr className="my-2" />
              <div className="row g-2 mb-2">
                <div className="col-6">
                  <div className="modal-label">
                    <b>Reason:</b>
                  </div>
                  <div className="modal-value">
                    {selectedAppointment.reason || (
                      <span className="text-danger">N/A</span>
                    )}
                  </div>
                </div>
                <div className="col-6">
                  <b>Status:</b>{' '}
                  <span
                    style={{
                      color: '#fff',
                      background: getStatusColor(selectedAppointment.status),
                      padding: '2px 10px',
                      borderRadius: '8px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                    }}
                  >
                    <span
                      className="material-icons"
                      style={{ fontSize: '16px' }}
                    >
                      {getStatusIcon(selectedAppointment.status)}
                    </span>
                    {selectedAppointment.status}
                  </span>
                </div>
                <div className="col-6">
                  <div className="modal-label">
                    <b>Date:</b>
                  </div>
                  <div className="modal-value">
                    {moment(selectedAppointment.start)
                      .tz('Asia/Kolkata')
                      .format('YYYY-MM-DD')}
                  </div>
                </div>
                <div className="col-6">
                  <div className="modal-label">
                    <b>Time:</b>
                  </div>
                  <div className="modal-value">
                    {moment(selectedAppointment.start)
                      .tz('Asia/Kolkata')
                      .format('HH:mm')}{' '}
                    -{' '}
                    {moment(selectedAppointment.end)
                      .tz('Asia/Kolkata')
                      .format('HH:mm')}
                  </div>
                </div>
              </div>
              <Form className="mt-2">
                <Form.Group className="mb-2">
                  <Form.Label
                    className="fw-semibold"
                    style={{ color: 'var(--primary-color)', fontSize: '1rem' }}
                  >
                    Notes
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    className="form-textarea"
                    style={{
                      minHeight: 40,
                      fontSize: '0.97rem',
                      resize: 'vertical',
                    }}
                    placeholder="Enter notes..."
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer className="border-0 d-flex justify-content-end gap-2">
              {selectedAppointment.status &&
                selectedAppointment.status.toLowerCase() === 'pending' && (
                  <>
                    <Button
                      className="global-btn"
                      onClick={() => handleStatusChange('confirmed')}
                    >
                      Confirm
                    </Button>
                    <Button
                      className="global-btn"
                      onClick={() => handleStatusChange('cancel')}
                    >
                      Cancel
                    </Button>
                  </>
                )}
              {selectedAppointment.status &&
                selectedAppointment.status.toLowerCase() === 'confirmed' && (
                  <>
                    <Button
                      className="global-btn"
                      onClick={() => handleStatusChange('completed')}
                    >
                      Completed
                    </Button>
                    <Button
                      className="global-btn"
                      onClick={() => handleStatusChange('cancel')}
                    >
                      Cancel
                    </Button>
                  </>
                )}
            </Modal.Footer>
          </Modal>
        )}

        {/* Prescription Modal */}
        <Modal
          show={showPrescriptionModal}
          onHide={() => setShowPrescriptionModal(false)}
          centered
          backdrop="static"
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>              
              <h5 className="fw-bold globle-heading primary-class">
                    Prescription Management
              </h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Prescription
              patientId={selectedAppointment?.patient_id}
              appointment={selectedAppointment}
              onClose={() => setShowPrescriptionModal(false)}
            />
          </Modal.Body>
        </Modal>

        {/* LabTest Modal */}
        <Modal
          show={showLabTestModal}
          onHide={() => setShowLabTestModal(false)}
          centered
          backdrop="static"
          size="md"
        >
          <Modal.Header closeButton>
            <Modal.Title >
               <h5 className="fw-bold globle-heading primary-class">
              Lab Test Request</h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <LabTest
              appointment={selectedAppointment}
              onClose={() => setShowLabTestModal(false)}
            />
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default DoctorDashboard;
